import React from 'react';
import { motion } from 'framer-motion';
import { SmartphoneIcon, SparklesIcon, FlowerIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/ocgfBLBq8orXEV2J28pDho/principal_.webp';
type HeroProps = {
  onCTA: () => void;
};
export function Hero({
  onCTA
}: HeroProps) {
  return <section id="inicio" className="relative w-full overflow-hidden bg-crema pt-28 pb-16 sm:pt-32 sm:pb-24" data-id="element-88" data-mp="4njq6ckn7zc1">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-10" data-id="element-89" data-mp="xae7j0m5yila">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="order-2 text-center lg:order-1 lg:text-left" data-id="element-90" data-mp="sb1bbp9ejz61">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-white/70 px-4 py-1.5 text-xs font-medium uppercase tracking-[0.18em] text-dorado shadow-sm" data-id="element-91" data-mp="380vz9yqbyvdo">
            <SparklesIcon className="h-3.5 w-3.5" strokeWidth={2} data-id="element-92" data-mp="3o7vgxbbup7t2" />
            Programa guiado de 30 días
          </span>
          <h1 className="font-serif text-4xl font-semibold leading-[1.1] text-tinta sm:text-5xl lg:text-6xl" data-id="element-93" data-mp="399tdr28qeocc">
            Deja de despertar agotada.
            <span className="block text-rosa-dark" data-id="element-94" data-mp="30ib0az366mmy">
              Reconecta con la mujer con energía que eres.
            </span>
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-tinta/75 lg:mx-0" data-id="element-95" data-mp="359j6lm97drvw">
            Un método suave, día por día, para recuperar tu energía,
            desinflamarte y equilibrar tu metabolismo hormonal. Todo desde tu
            celular, a tu ritmo y en la palma de tu mano.
          </p>
          <div className="mt-9 flex flex-col items-center gap-4 sm:flex-row lg:justify-start" data-id="element-96" data-mp="2hjyot6osd0o7">
            <CTAButton onClick={onCTA} icon={SmartphoneIcon} size="lg" data-id="element-97" data-mp="2lk8qw89gj6xs">
              Quiero mi app ahora
            </CTAButton>
            <span className="text-sm text-tinta/60" data-id="element-98" data-mp="nbbcwylbob5a">Acceso inmediato</span>
          </div>
          <p className="mt-5 inline-flex items-center gap-2 text-sm text-rosa-dark" data-id="element-99" data-mp="n9i3xcn8leu4">
            <FlowerIcon className="h-4 w-4 shrink-0" strokeWidth={1.8} data-id="element-100" data-mp="ici0zaloos78" />
            Más de 200 mujeres ya comenzaron su cambio hormonal
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: [0.22, 1, 0.36, 1]
      }} className="order-1 lg:order-2" data-id="element-101" data-mp="1azktnm3oi8pk">
          <div className="relative mx-auto max-w-md overflow-hidden rounded-[2rem] shadow-2xl shadow-rosa/20 ring-1 ring-white/60" data-id="element-102" data-mp="3lsp2pbkjgfdd">
            <img src={HERO_IMG} alt="Mujer serena vestida de blanco, rodeada de flores y luz cálida" className="h-full w-full object-cover" loading="eager" data-id="element-103" data-mp="3hqagqilkozhv" />
          </div>
        </motion.div>
      </div>
    </section>;
}